function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useQuery } from '@tanstack/react-query';
import { canManageSubscriptionKey, canViewSubscriptionKey, getCanManageSubscription, getCanViewSubscription } from '@ui/guards/subscription';
import { useCurrentUser } from './current-user';
function canViewSubscriptionQuery(param) {
    let { organization, user } = param;
    var _ref;
    return {
        queryKey: [
            canViewSubscriptionKey,
            organization !== null && organization !== void 0 ? organization : '',
            (_ref = user === null || user === void 0 ? void 0 : user.id) !== null && _ref !== void 0 ? _ref : ''
        ],
        queryFn: async ()=>{
            if (!organization || !user) {
                return false;
            }
            return getCanViewSubscription(organization, user);
        }
    };
}
function canManageSubscriptionQuery(param) {
    let { organization, user } = param;
    var _ref;
    return {
        queryKey: [
            canManageSubscriptionKey,
            organization !== null && organization !== void 0 ? organization : '',
            (_ref = user === null || user === void 0 ? void 0 : user.id) !== null && _ref !== void 0 ? _ref : ''
        ],
        queryFn: async ()=>{
            if (!organization || !user) {
                return false;
            }
            return getCanManageSubscription(organization, user);
        }
    };
}
export function useUserCanViewSubscription(params) {
    const { user } = useCurrentUser();
    const { isLoading, data: can, error } = useQuery(canViewSubscriptionQuery(_object_spread_props(_object_spread({}, params), {
        user
    })));
    return {
        can,
        isLoading,
        error
    };
}
export function useUserCanManageSubscription(params) {
    const { user } = useCurrentUser();
    const { isLoading, data: can, error } = useQuery(canManageSubscriptionQuery(_object_spread_props(_object_spread({}, params), {
        user
    })));
    return {
        can,
        isLoading,
        error
    };
}
